<template>
    <transition name="modal">
        <div id="blog-modal" v-if="showModal">
            <div class="modal-inner" ref="scrollContainer">

                <div class="modal-header">
                    <div class="tbl-t d-none d-sm-none d-md-table header-large">
                        <div class="tbl-r">
                            <div class="tbl-c">
                                <blog-avatar :blog="blog" :w="40" :h="40" class="d-none d-md-inline-block"/>
                                <span class="title">{{blog.title | maxlen(35)}}</span>
                            </div>
                            <div class="tbl-c text-right">
                                <button
                                  v-if="hasBlogList"
                                  class="btn btn-outline-primary"
                                  :disabled="(prevBlog === null)"
                                  @click.prevent="loadPrev()">
                                    <fa-icon :icon="['fal','chevron-left']"/>
                                </button>
                                <follow-button :blog="blog" />
                                <button
                                  v-if="isLoggedIn"
                                  class="btn btn-outline-primary"
                                  @click.prevent="sendMessage">
                                  <fa-icon :icon="['fal', 'comment']"/>
                                  <span class="hidden-xs hidden-sm">Send Message</span>
                                </button>
                                <button
                                  v-if="hasBlogList"
                                  class="btn btn-outline-primary"
                                  :disabled="(nextBlog === null)"
                                  @click.prevent="loadNext()">
                                    <fa-icon :icon="['fal','chevron-right']"/>
                                </button>

                                <button class="btn closeBtn" @click.prevent="closeModal"><icon icon="times" size="2x"/> </button>
                            </div>
                        </div>
                    </div>


                    <div class="d-md-none header-small">
                        <div class="tbl-t">
                            <div class="tbl-r">
                                <div class="tbl-c">

                                  <button
                                    v-if="hasBlogList"
                                    class="btn btn-outline-primary"
                                    :disabled="(prevBlog === null)"
                                    @click.prevent="loadPrev()">
                                    <fa-icon :icon="['fal','chevron-left']"/>
                                  </button>
                                  <follow-button :blog="blog" />
                                  <button
                                    v-if="isLoggedIn"
                                    class="btn btn-outline-primary"
                                    @click.prevent="sendMessage">
                                    <fa-icon :icon="['fal', 'comment']"/>
                                  </button>
                                  <button
                                    v-if="hasBlogList"
                                    class="btn btn-outline-primary"
                                    :disabled="(nextBlog === null)"
                                    @click.prevent="loadNext()">
                                    <fa-icon :icon="['fal','chevron-right']"/>
                                  </button>




                                </div>
                                <div class="tbl-c text-right">
                                  <button class="btn closeBtn" @click.prevent="closeModal"><icon icon="times" size="2x"/> </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <blog-avatar :blog="blog" :w="40" :h="40"/>
                            <span class="title">{{blog.title | maxlen(35)}}</span>
                        </div>
                    </div>

                </div>

                <posts v-if="init" :blog="blog" :attach-scroll-listener="$refs" type="blog" />

                <p v-if="noResults" class="text-center">This blog has no posts yet. Please check back later.</p>

                <loading-indicator name="blog.getPosts"/>

            </div>
        </div>
    </transition>
</template>

<script>


    import Posts from '../posts/PostList.vue'
    import PostItem from '../posts/PostListItem.vue';
    import Icon from "../ui/Icon";
    import BlogAvatar from "../ui/BlogAvatar";
    import FollowButton from "../ui/buttons/FollowButton"
    import LoadingIndicator from "../ui/LoadingIndicator";

    export default {
        name: 'BlogModal',
        data() {
            return {
                init: false,
                showModal: false,
                blogUrl: '',
                blog:{},
                posts:[],
                displayVideoId: null,
                scrollContainer: null,
                noResults: null,
                hasBlogList: false,
                nextBlog: null,
                prevBlog: null
            }
        },
        computed: {
          isLoggedIn(){
            return this.$store.state.user.isLoggedIn;
          }
        },
        mounted() {


            /*this.$api.getBlog(this.blogUrl).then((res)=>{
                this.blog = res.data.blog;
                this.init = true;
            });*/


            this.$bus.$on('blog-modal.open', (data)=>{
                this.noResults = null;
                this.scrollContainer = this.$refs.container;
                this.$bus.$emit('modal.open', 'blog-modal');
                this.blog = data.blog;
                this.init = true;
                this.showModal = true;

                // Used for prev/next
                this.hasBlogList = false;
                this.nextBlog = null;
                this.prevBlog = null;
                this.$bus.$emit('bloglist.exists', {currentBlog: this.blog});
            });

            this.$bus.$on('blog-modal.close', (data)=>{
              this.noResults = null;
              this.hasBlogList = false;
              this.nextBlog = null;
              this.prevBlog = null;
            });

            this.$bus.$on('postlist.noresults', (data)=>{
                this.noResults = data.type;
            });

            // List Prev/next
            this.$bus.$on('blog-modal.listExists', (data)=>{
              this.hasBlogList = true;
              if(data.nextBlog) this.nextBlog = data.nextBlog;
              if(data.prevBlog) this.prevBlog = data.prevBlog;
            })
        },
        methods: {
            displayVideo(){
                if(this.displayVideoId){
                    this.$api.getPost(this.displayVideoId)
                        .then((res)=>{
                            this.$bus.$emit('playVideo', res.data.post);
                        });
                }
            },
            closeModal(){
                this.showModal = false;
                this.$bus.$emit('blog-modal.close');
                this.$bus.$emit('modal.close', 'blog-modal');
            },
            loadNext() {
                this.$bus.$emit('blog-modal.open', {blog: this.nextBlog});
            },
            loadPrev() {
                this.$bus.$emit('blog-modal.open', {blog: this.prevBlog});
            },
            sendMessage() {
                this.$router.push({name: 'MessageToBlog', params:{blogUrl: this.blog.url}});
                this.closeModal();
            }
        },
        components:{
          LoadingIndicator,
          Icon,
            Posts,
            PostItem,
            BlogAvatar,
            FollowButton
        }
    }
</script>

<style scoped lang="sass">

    @import '../../assets/sass/vars.scss'

    #blog-modal
        position: fixed
        top: 0px
        left: 0px
        right: 0px
        bottom: 0px
        background-color: rgba(0, 0, 0, .5)
        transition: all .3s ease
        z-index: $z-blogModal

    .modal-inner
        position: fixed
        top: 10px
        left: 10px
        right: 10px
        bottom: 0px
        background-color: #FFFFFF
        box-shadow: 0 2px 10px rgba(0,0,0,.1)
        overflow-y: scroll
        padding-top: 80px

        @media screen and (max-width: 768px)
            padding-top: 120px

    .modal-header
        position: fixed
        top: 10px
        left: 10px
        right: 10px
        z-index: 5
        background-color: rgba(255,255,255,.95)
        padding: 10px

        .title
            display: inline-block
            padding-left: .5em
            font-size: 1.5em


        .closeBtn
          opacity: .7
          background-color: transparent

          &:hover
            opacity: 1

    .tbl-t
        display: table
        width: 100%


        .tbl-r
            display: table-row


            .tbl-c
                display: table-cell
                height: 50px
                overflow: hidden


    .header-small
        width: 100%
        font-size: .8em

    .modal-enter
        opacity: 0

    .modal-leave-active
        opacity: 0

    .modal-enter #blog-modal,
    .modal-leave-active #blog-modal
        -webkit-transform: translateY(80px)
        transform: translateY(80px)


</style>



// WEBPACK FOOTER //
// src/components/blogs/BlogModal.vue